import React, { Children } from 'react'

export const Button = ({children}) => {
  return (
    <div>
        <button className='w-64 text-xl bg-gradient-to-r from-blue-500 to-blue-700 rounded-lg px-5 py-2.5 font-medium text-white'>{children}</button>
    </div>
  )
}
